// extracted by mini-css-extract-plugin
export var container = "_5r-0";
export var infoButton = "_5r-1";
export var label = "_5r-3";
export var labelExpanded = "_5r-4";
export var price = "_5r-5";
export var priceExpanded = "_5r-6";
export var title = "_5r-2";